import React, { useEffect, useState } from 'react'
import "./ResetPassword.css"; // Import custom CSS
import BackgroundVideo from '../BackgroundVideo/BackgroundVideo';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';

const ResetPassword = () => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const guid = params.get("guid");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [message, setMessage] = useState("");
    const [errors, setErrors] = useState({ newPassword: "", confirmPassword: "" });
    const [invalidMsg, setInvalidMsg] = useState("");
    const [isValid, setIsValid] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const verifyUrl = async () => {
            try {  
                if (guid) {
                    const response = await fetch(process.env.REACT_APP_API_BASE_URL + "api/apiCallV1", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            mode: "verifyuser",
                            guid: guid,
                        }),
                    });
                    const data = await response.json();
                    if (data?.header?.status == 200) {
                        setIsValid(true);
                        if (window.history.replaceState) {
                            params.delete('guid');
                            const newUrl = `${window.location.pathname}`;
                            window.history.replaceState({}, '', newUrl);
                        }
                    } else {
                        setIsValid(false);
                        setInvalidMsg("Invalid URL");
                    }
                } else {
                    setIsValid(false);
                    setInvalidMsg("Invalid URL");
                }                
            } catch (error) {
                console.error("Error in CheckEmailExist:", error);
                throw error;
            }
        }
        verifyUrl();
    }, []);

    const validatePassword = (password: string) => {
        const minLength = password.length >= 8;
        const hasUpperCase = /[A-Z]/.test(password);
        const hasLowerCase = /[a-z]/.test(password);
        const hasNumber = /\d/.test(password);
        const hasSpecialChar = /[@$!%*?&]/.test(password);

        if (!minLength) return "Password must be at least 8 characters long.";
        if (!hasUpperCase) return "Password must contain at least one uppercase letter.";
        if (!hasLowerCase) return "Password must contain at least one lowercase letter.";
        if (!hasNumber) return "Password must contain at least one number.";
        if (!hasSpecialChar) return "Password must contain at least one special character (@$!%*?&).";
        return "";
    };

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        const newPasswordError = validatePassword(newPassword);
        const confirmPasswordError = newPassword !== confirmPassword ? "Passwords do not match!" : "";

        if (newPasswordError || confirmPasswordError) {
            setErrors({ newPassword: newPasswordError, confirmPassword: confirmPasswordError });
            return;
        }

        if(newPassword && confirmPassword) {
            if (newPassword !== confirmPassword) {
                toast.error("Passwords does not match!", { autoClose: 3000 });
            } else {
                const response = await fetch(process.env.REACT_APP_API_BASE_URL + "api/resetpassword", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        guid: guid,
                        password: newPassword
                    }),
                });
        
                const data = await response.json();
                if (data?.header?.status == 200) {
                    toast.success(data?.header?.message || "Password updated successfully", { autoClose: 3000 });
                    const timer = setTimeout(() => {
                        navigate('/', { replace: true });
                      }, 3000);
                } else {
                    toast.error(data?.header?.message || "Failed to update password.", { autoClose: 3000 });
                }
            }
        }
    };

    return (
        isValid ? (<React.StrictMode>
            <ToastContainer />
            <BackgroundVideo mode={""} />
            <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100vh",
            }}>
                <div className="reset-container">
                    <div className="reset-box">
                        {/* <div style={{ display: "flex", justifyContent: "end", alignItems: "center" }}>
                            <img
                                src="/images/closeicon.svg"
                                alt="Close"
                                onClick={onClose} 
                                style={{
                                    cursor: "pointer",
                                    width: "12px",
                                    height: "12px",
                                }}
                            />
                        </div> */}
                        <h2>Reset Your Password</h2>
                        <p>Enter a new password for your account.</p>
                        <form onSubmit={handleSubmit}>
                            <div className="input-group">
                                <label>New Password</label>
                                <input
                                    type="password"
                                    placeholder="Enter new password"
                                    value={newPassword}
                                    maxLength={20}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    required
                                />
                                {errors.newPassword && <p className="error-message">{errors.newPassword}</p>}
                            </div>

                            <div className="input-group">
                                <label>Confirm Password</label>
                                <input
                                    type="password"
                                    placeholder="Confirm new password"
                                    value={confirmPassword}
                                    maxLength={20}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    required
                                />
                                {errors.confirmPassword && <p className="error-message">{errors.confirmPassword}</p>}
                            </div>

                            <button type="submit">Reset Password</button>
                        </form>

                        {message && <p className="message">{message}</p>}
                    </div>
                </div>
            </div>
        </React.StrictMode>) : (<div>{invalidMsg}</div>)
    )
}

export default ResetPassword